/* Bob Logistics Worldwide — destination selector */
(function () {
  var KEY = 'giftgo_destination';
  var CODE_MAP = { us: 'US', gb: 'UK', ca: 'CA', de: 'DE', ng: 'NG', worldwide: 'WW' };

  class GiftgoDestination extends HTMLElement {
    connectedCallback() {
      this.pill = this.querySelector('[data-destination-pill]');
      this.dialog = this.querySelector('dialog');
      this.nameEl = this.querySelector('[data-pill-name]');
      this.flagEl = this.querySelector('[data-pill-flag]');
      this.options = Array.from(this.querySelectorAll('.giftgo-dest__opt'));

      if (this.pill) this.pill.addEventListener('click', () => this.open());
      var closeBtn = this.querySelector('.giftgo-dest__close');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (this.dialog) {
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      }
      this.options.forEach((opt) => opt.addEventListener('click', () => this.choose(opt)));

      var saved = this.read();
      if (saved) {
        this.apply(saved.code, saved.name, false);
      } else {
        // No destination chosen yet — default to United States, then prompt.
        this.apply('us', 'United States', false);
        this.open();
      }
    }

    open() { if (this.dialog && this.dialog.showModal) this.dialog.showModal(); }
    close() { if (this.dialog && this.dialog.close) this.dialog.close(); }

    choose(opt) {
      var code = opt.dataset.code;
      var name = opt.dataset.name;
      this.apply(code, name, true);
      this.close();
    }

    apply(code, name, persist) {
      if (this.nameEl) this.nameEl.textContent = name;
      if (!this.codeEl) this.codeEl = this.querySelector('[data-pill-code]');
      if (this.codeEl) this.codeEl.textContent = CODE_MAP[code] || 'WW';
      if (this.flagEl) {
        var src = this.querySelector('.giftgo-dest__opt[data-code="' + code + '"] .destination-pill__flag');
        if (src) this.flagEl.innerHTML = src.innerHTML;
      }
      this.options.forEach((o) => o.setAttribute('aria-checked', o.dataset.code === code ? 'true' : 'false'));
      document.documentElement.setAttribute('data-destination', code);
      if (persist) {
        try { localStorage.setItem(KEY, JSON.stringify({ code: code, name: name })); } catch (e) {}
        document.cookie = 'giftgo_dest=' + code + ';path=/;max-age=31536000';
      }
      this.filter(code);
      document.dispatchEvent(new CustomEvent('giftgo:destination', { detail: { code: code, name: name } }));
    }

    read() {
      try { var v = localStorage.getItem(KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; }
    }

    /* Show/hide any element tagged with data-giftgo-dest="us gb ..." based on destination.
       "worldwide" (Send Anywhere) shows everything. */
    filter(code) {
      var els = document.querySelectorAll('[data-giftgo-dest]');
      els.forEach(function (el) {
        var dests = (el.getAttribute('data-giftgo-dest') || '').split(/\s+/);
        var show = code === 'worldwide' || dests.indexOf('worldwide') !== -1 || dests.indexOf(code) !== -1 || dests.length === 0 || dests[0] === '';
        el.hidden = !show;
      });
    }
  }
  if (!customElements.get('giftgo-destination')) customElements.define('giftgo-destination', GiftgoDestination);

  /* ---- Product-page delivery box ---- */
  class GiftgoDelivery extends HTMLElement {
    connectedCallback() {
      this.speed = this.dataset.speed || 'standard';
      this.flagEl = this.querySelector('[data-gg-flag]');
      this.countryEl = this.querySelector('[data-gg-country]');
      this.etaEl = this.querySelector('[data-gg-eta]');
      var change = this.querySelector('[data-gg-change]');
      if (change) change.addEventListener('click', function () {
        var d = document.querySelector('giftgo-destination');
        if (d && d.open) d.open();
      });
      document.addEventListener('giftgo:destination', this.onDest.bind(this));
      this.render(this.readSaved());
    }

    readSaved() {
      try { var v = localStorage.getItem(KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; }
    }

    onDest(e) { if (e && e.detail) this.render(e.detail); }

    render(dest) {
      if (dest && dest.code) {
        if (this.countryEl) this.countryEl.textContent = dest.name;
        var src = document.querySelector('.giftgo-dest__opt[data-code="' + dest.code + '"] .destination-pill__flag');
        if (src && this.flagEl) this.flagEl.innerHTML = src.innerHTML;
      }
      if (this.etaEl) this.etaEl.textContent = this.etaText();
    }

    etaText() {
      if (this.speed === '30-min') return 'Delivered in about 30 minutes.';
      if (this.speed === 'same-day') return 'Delivered today.';
            var rng = /^(\d+)-(\d+)-days$/.exec(this.speed || '');
      if (rng) { var f = function (n) { var x = new Date(); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }; return 'Estimated delivery: ' + f(+rng[1]) + ' – ' + f(+rng[2]) + '.'; }
      var days = this.speed === 'express' ? 1 : 7;
      var d = new Date();
      d.setDate(d.getDate() + days);
      var fmt = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      return 'Delivered by ' + fmt + '.';
    }
  }
  if (!customElements.get('giftgo-delivery')) customElements.define('giftgo-delivery', GiftgoDelivery);
})();
